/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentOngoingStatusFault } from "./PaymentOngoingStatusFault";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum FaultCodeCategoryEnum {
  "PAYMENT_ONGOING" = "PAYMENT_ONGOING"
}

/**
 * A PaymentProblemJson-like type specific for the GetPayment and ActivatePayment operations.
 * Possible values of `detail_v2` are limited to faults pertaining to Nodo errors related to payment status conflicts.
 */

// required attributes
const PaymentOngoingStatusFaultPaymentProblemJsonR = t.interface({
  faultCodeCategory: enumType<FaultCodeCategoryEnum>(
    FaultCodeCategoryEnum,
    "faultCodeCategory"
  ),

  faultCodeDetail: PaymentOngoingStatusFault
});

// optional attributes
const PaymentOngoingStatusFaultPaymentProblemJsonO = t.partial({
  title: t.string
});

export const PaymentOngoingStatusFaultPaymentProblemJson = t.intersection(
  [
    PaymentOngoingStatusFaultPaymentProblemJsonR,
    PaymentOngoingStatusFaultPaymentProblemJsonO
  ],
  "PaymentOngoingStatusFaultPaymentProblemJson"
);

export type PaymentOngoingStatusFaultPaymentProblemJson = t.TypeOf<
  typeof PaymentOngoingStatusFaultPaymentProblemJson
>;
